import { i18nReducer } from "react-redux-i18n";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { thunk } from "redux-thunk";

import accessReducer from "./reducers/access";
import authReducer from "./reducers/auth";
import blockListReducer from "./reducers/block-list";
import clientReducer from "./reducers/client";
import complaintReducer from "./reducers/complaint";
import consolidatedReducer from "./reducers/consolidated";
import contractReducer from "./reducers/contract";
import credenciadaCodeReducer from "./reducers/credenciada-code";
import distributorReducer from "./reducers/distributor";
import enumReducer from "./reducers/enum";
import hashAgencyReducer from "./reducers/hash-agency";
import installmentReducer from "./reducers/installment";
import jobLogReducer from "./reducers/jobLog";
import loadingReducer from "./reducers/loading";
import logReducer from "./reducers/log";
import partnerReducer from "./reducers/partner";
import preContractReducer from "./reducers/pre-contract";
import reportReducer from "./reducers/report";
import userReducer from "./reducers/user";

export default () => {
  const store = createStore(
    combineReducers({
      i18n: i18nReducer,
      auth: authReducer,
      loading: loadingReducer,
      user: userReducer,
      client: clientReducer,
      complaint: complaintReducer,
      access: accessReducer,
      partner: partnerReducer,
      contract: contractReducer,
      installment: installmentReducer,
      preContract: preContractReducer,
      log: logReducer,
      jobLog: jobLogReducer,
      blockList: blockListReducer,
      hashAgency: hashAgencyReducer,
      distributor: distributorReducer,
      consolidated: consolidatedReducer,
      report: reportReducer,
      credenciadaCode: credenciadaCodeReducer,
      enum: enumReducer,
    }),
    compose(
      applyMiddleware(thunk),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  );

  return store;
};
